import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ParItems from './ParItems';
import PageTitle from '../../../components/shared/PageTitle';
import PageArea from '../../../components/shared/PageArea';

const ParConfiguration = () => {
  const { t } = useTranslation('parConfiguration');

  return (
    <PageArea>
      <Box
        display='flex'
        flexDirection='column'
        flex={1}
        alignItems='start'
      >
        <PageTitle>{t('title')}</PageTitle>
      </Box>     
      <Box
        display='flex'
        flexDirection='column'
        flex={1}
      >
        <ParItems />
      </Box>
    </PageArea>
  );
};

export default ParConfiguration;